import CityConfigDao from "./CityConfigDao";
import { CityConfig, Sector, Zone } from "../model";
import { CityApiInterface, ParkingApiInterface } from "../swagger";

export class SwaggerCityConfigDao implements CityConfigDao {
  private readonly _citySwaggerClient: CityApiInterface;
  private readonly _parkingSwaggerClient: ParkingApiInterface;

  public constructor(
    citySwaggerClient: CityApiInterface,
    parkingSwaggerClient: ParkingApiInterface
  ) {
    this._citySwaggerClient = citySwaggerClient;
    this._parkingSwaggerClient = parkingSwaggerClient;
  }

  public async getCityConfig(): Promise<CityConfig> {
    try {
      const res = await this._citySwaggerClient.getCityConfig();

      return res.data as CityConfig;
    } catch (error) {
      throw error;
    }
  }

  public async getSectors(cityId: string): Promise<Sector[]> {
    try {
      const couchDbRes = (
        await this._parkingSwaggerClient.getParkingSections(cityId, true)
      ).data.rows;

      if (couchDbRes === undefined) return [];

      return couchDbRes
        .map(elt => {
          if (elt.id === undefined || elt.key === undefined) return undefined;

          return elt.doc;
        })
        .filter(item => item !== undefined) as Sector[];
    } catch (error) {
      throw error;
    }
  }

  public async getZones(cityId: string): Promise<Zone[]> {
    try {
      const couchDbRes = (
        await this._parkingSwaggerClient.getParkingAreas(cityId, true)
      ).data.rows;

      if (couchDbRes === undefined) return [];

      return couchDbRes
        .map(elt => {
          if (elt.id === undefined || elt.key === undefined) return undefined;

          return elt.doc;
        })
        .filter(item => item !== undefined) as Zone[];
    } catch (error) {
      throw error;
    }
  }
}

export default SwaggerCityConfigDao;
